import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isApiLoaded: false,
  isSignedIn: false,
  selectedFile: null,
  error: null,
};

export const googleDriveSlice = createSlice({
  name: 'googleDrive',
  initialState,
  reducers: {
    setApiLoaded: (state) => {
      state.isApiLoaded = true;
    },
    setSignedIn: (state, action) => {
      state.isSignedIn = action.payload;
    },
    setSelectedFile: (state, action) => {
      state.selectedFile = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    },
    resetDriveState: (state) => {
      state.isSignedIn = false;
      state.selectedFile = null;
      state.error = null;
    },
  },
});

export const {
  setApiLoaded,
  setSignedIn,
  setSelectedFile,
  setError,
  resetDriveState,
} = googleDriveSlice.actions;

export default googleDriveSlice.reducer;